// Pieces the Money sheets share, ported from the Deposit and Withdraw designs (App39, App74, App40, App75).
import type { ReactNode } from "react";
import { go } from "../router.js";

/** The blurred lobby behind a Money sheet, and the dimmed layer over it. Tapping outside closes the sheet. */
export function SheetBackdrop() {
  return (
    <>
      <div aria-hidden="true" style={{ position: "absolute", inset: "0", filter: "blur(6px)", opacity: "0.4" }}>
        <div style={{ position: "absolute", left: "20px", right: "20px", top: "110px", height: "230px", borderRadius: "26px", background: "linear-gradient(160deg, #1A2210, #10141B 55%)" }}></div>
        <div style={{ position: "absolute", left: "20px", right: "20px", top: "360px", height: "70px", borderRadius: "18px", background: "#161B22" }}></div>
      </div>
      <div className="scrim" onClick={() => go("App28", true)}></div>
    </>
  );
}

export function SheetTitle({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="grab"></div>
      <div className="row">
        <span className="h2">{children}</span>
        <button onClick={() => go("App28", true)} className="ib" aria-label="Close" style={{ cursor: "pointer" }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>
      </div>
    </>
  );
}

const TAB_ON = { height: "36px", borderRadius: "11px", display: "flex", alignItems: "center", justifyContent: "center", background: "#CCFF00", color: "#0B0E14", fontWeight: "700", fontSize: "13px", border: "0", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap", padding: "0 6px" } as const;
const TAB_OFF = { ...TAB_ON, background: "transparent", color: "#8B949E", fontWeight: "600" } as const;

/** The two ways to deposit: from the connected wallet, or by sending from @wallet or an exchange. */
export function DepositTabs({ active }: { active: "wallet" | "address" }) {
  return (
    <div role="tablist" style={{ marginTop: "14px", display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "4px", padding: "4px", borderRadius: "14px", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)" }}>
      <button role="tab" aria-selected={active === "wallet"} onClick={() => go("App39", true)} style={{ ...(active === "wallet" ? TAB_ON : TAB_OFF), fontWeight: active === "wallet" ? 700 : 600 }}>My wallet</button>
      <button role="tab" aria-selected={active === "address"} onClick={() => go("App74", true)} style={{ ...(active === "address" ? TAB_ON : TAB_OFF), fontWeight: active === "address" ? 700 : 600 }}>@wallet or exchange</button>
    </div>
  );
}

/** A label and value line inside a details card, with the divider above it unless it is the first. */
export function Line({ label, children, first }: { label: string; children: ReactNode; first?: boolean }) {
  return (
    <>
      {!first && <div className="div" style={{ margin: "0 14px" }}></div>}
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>{label}</span><span style={{ fontSize: "13px", textAlign: "right" }}>{children}</span></div>
    </>
  );
}

/** A problem the player can act on, shown above the main button. */
export function Notice({ children }: { children: ReactNode }) {
  return (
    <div role="alert" style={{ marginTop: "10px", padding: "10px 14px", borderRadius: "14px", background: "rgba(255,51,102,0.1)", border: "1px solid rgba(255,51,102,0.35)", color: "#FF5C85", fontSize: "13px", lineHeight: "18px" }}>{children}</div>
  );
}
